(function () {
    if (window.__customTestimonialHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.customTestimonial = window.Branch.customTestimonial || {};
    window.Branch.customTestimonial.sliders = window.Branch.customTestimonial.sliders || {};

    window.__customTestimonialHasFired = true;

  function initCustomTestimonial(customTestimonial, parent){
      console.log('initCustomTestimonial', customTestimonial, parent);
      let imagesArray = [];
      customTestimonial.querySelectorAll('.swiper-slide').forEach((slide) => {
        imagesArray.push(`${slide.getAttribute('data-nav-image')}`)
      });
      let selector = `#${parent.id} .c-t-slider`;
      let params = {
        slidesPerView: 1,
        spaceBetween: 0,
        freeMode: false,
        loop: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        },
        scrollbar: {
          el: ".c-t-slider-nav-inner-container .swiper-scrollbar",
          horizontalClass: 'swiper-scrollbar-horizontal',
          hide: false,
        },
        pagination: {
          el: ".c-t-slider-nav-inner-container .swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
              return '<span class="' + className + '">' + `<img loading="lazy" width="150" height="150" sizes="170px" srcset="${window.Branch.functions.returnSrcSet(imagesArray[index])}" src="${imagesArray[index]}"/>` + '</span>';
            },
        }
      };
  
      var customTestimonalSwiper = new Swiper(selector, params);
}
  

    function actionsOnVisible(uninitializedCustomTestimonial, parent){
      console.log(('actionsOnVisible'));
      uninitializedCustomTestimonial.setAttribute('data-interacted', true);
      initCustomTestimonial(uninitializedCustomTestimonial, parent)
    }

    function initCustomTestimonialCallback(uninitializedCustomTestimonial, parent, type){
        let fromLoad = uninitializedCustomTestimonial.closest('.homepage-content-container') && uninitializedCustomTestimonial.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(uninitializedCustomTestimonial, parent);
        } else if(!uninitializedCustomTestimonial.closest('.homepage-content-container')){
            actionsOnVisible(uninitializedCustomTestimonial, parent);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = uninitializedCustomTestimonial.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                uninitializedCustomTestimonial.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(uninitializedCustomTestimonial, parent);
                uninitializedCustomTestimonial.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.customTestimonial.initCustomTestimonial = function(type){
        let uninitializedcustomTestimonial = document.querySelectorAll('.shopify-section.custom-testimonial:not([data-initialized="true"])');
        uninitializedcustomTestimonial.forEach((uninitializedCustomTestimonial) => {
            let parent = uninitializedCustomTestimonial.closest('.shopify-section');
            uninitializedCustomTestimonial.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                initCustomTestimonialCallback(uninitializedCustomTestimonial, parent, type)
            } else {
                window.Branch.functions.fireOnUserInteraction(initCustomTestimonialCallback,  '.homepage-content-container', uninitializedCustomTestimonial, uninitializedCustomTestimonial, parent);
            }
        })
    }

    if (document.readyState === "complete") {
        window.Branch.customTestimonial.initCustomTestimonial('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.customTestimonial.initCustomTestimonial('regular'));
    }
  })();
